<template>
  <b-row class="justify-content-xl-center">
    <b-col class="col-xl-10">
      <div v-if="!step">
        <h3>Schule registrieren</h3>

        <p>
          Um Ihre Schule für den Wettbewerb anzumelden, müssen Sie zunächst
          ein Benutzerkonto für den betreuenden Lehrer erstellen.
        </p>
        <registrationForm v-if="!step" v-bind:registration="registration"></registrationForm>
      </div>

      <registrationConfirmation v-else v-bind:registration="registration"></registrationConfirmation>
    </b-col>
  </b-row>
</template>

<script>

import Form from './Form'
import Confirmation from './Confirmation'
import { getCountryByHost } from '@/lib/locale'

export default {
  name: 'registration',

  components: {
    'registrationForm': Form,
    'registrationConfirmation': Confirmation
  },

  data () {
    return {
      registration: {
        country: getCountryByHost().code,
        gender: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        token: ''
      },
      step: 0
    }
  },

  methods: {
    send: function () {
      this.axios.post('/registration', JSON.stringify(this.registration)).then(() => {
        this.$eventHub.$emit('alertHide')
        this.step = 1
      }).catch((error) => {
        this.$eventHub.$emit('error', error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/views/guests/registration/Registration.vue